export class CountryModel {
  constructor(
    public id: number = -1,
    public isoCode: string = null,
    public label: string = null
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
